$(document).ready(function() {
    $('#algemene-aanvraag-form .next-step').on('click', globalRequestForm.nextStep);
    $('#algemene-aanvraag-form .prev-step').on('click', globalRequestForm.prevStep);

    $('#algemene-aanvraag-form input[name="categories[]"]').each((i, element) => {
        if (element.checked) {
            $('[data-category-section="' + $(element).val() + '"]').show();
        } else {
            $('[data-category-section="' + $(element).val() + '"]').hide();
        }
    });

    $('#algemene-aanvraag-form input[name="categories[]"]').on('change', function() {
        if (this.checked) {
            $('[data-category-section="' + $(this).val() + '"]').show();
        } else {
            $('[data-category-section="' + $(this).val() + '"]').hide();
        }
    });
});


var globalRequestForm = {
    currentStep: 1,
    step1Valid: function() {
        if (
            !$("input[name='firstname']")[0].checkValidity() ||
            !$("input[name='lastname']")[0].checkValidity() ||
            !$("input[name='client_email']")[0].checkValidity()
        ) {
            $("#submit-hidden").click();
            return false;
        }

        return true;
    },
    step2Valid: function() {
        if (
            !$("input[name='event_date']")[0].checkValidity() ||
            !$("input[name='start_time']")[0].checkValidity() ||
            !$("input[name='end_time']")[0].checkValidity() ||
            !$("select[name='occasion']")[0].checkValidity() ||
            !$("textarea[name='text']")[0].checkValidity() ||
            !$("select[name='region']")[0].checkValidity()
        ) {
            $("#submit-hidden").click();
            return false;
        }

        return true;
    },
    step3Valid: function() {
        return $('input[name="categories[]"]:checked').length > 0;
    },
    step4Valid: function() {
        return $('input[name="specialities[]"]:checked').length > 0;
    },
    prevStep: function(e) {
        e.preventDefault();

        globalRequestForm.currentStep--;

        $('.step-bar .step').removeClass('active');

        $('.step-bar .step-' + globalRequestForm.currentStep).removeClass('completed');
        $('.step-bar .step-' + globalRequestForm.currentStep).addClass('active');

        $('.form-step').hide();

        $('.form-step.step-' + globalRequestForm.currentStep).show();

        if (globalRequestForm.currentStep === 1) {
            $('.prev-step').hide();
        }
    },
    nextStep: function(e) {
        e.preventDefault();

        if (globalRequestForm.currentStep === 4) {
            return false;
        }

        if (globalRequestForm.currentStep === 1) {
            if (!globalRequestForm.step1Valid()) {
                return false;
            }
        }

        if (globalRequestForm.currentStep === 2) {
            if (!globalRequestForm.step2Valid()) {
                return false;
            }
        }

        if (globalRequestForm.currentStep === 3) {
            if (!globalRequestForm.step3Valid()) {
                return false;
            }
        }

        if (globalRequestForm.currentStep === 4) {
            if (!globalRequestForm.step4Valid()) {
                return false;
            }
        }

        $('.step-bar .step').removeClass('active');
        $('.step-bar .step-' + globalRequestForm.currentStep).addClass('completed');

        globalRequestForm.currentStep++;

        $('.step-bar .step-' + globalRequestForm.currentStep).addClass('active');

        $('.form-step').hide();

        $('.form-step.step-' + globalRequestForm.currentStep).show();

        if (globalRequestForm.currentStep === 4) {
            $('.next-step').hide();
            $('.prev-step').hide();
            $('.submit-wrapper').show();
        } else {
            $('.submit-wrapper').hide();
        }

        if (globalRequestForm.currentStep > 1 && globalRequestForm.currentStep !== 4) {
            $('.prev-step').show();
        }

        $([document.documentElement, document.body]).animate({
            scrollTop: $(".step-bar").offset().top
        }, 100);
    }
};
